<template>
	<div :class="['module-list']">
		<app-table
			class="mt-5 is-not-selectable"
			name="modules"
			:columns="columns"
			:current-page="currentPage"
			:last-page="lastPage"
			:rows="rows"
			@on-search-event="$emit('on-search', $event)"
			@on-page="$emit('on-page', $event)"
		>
			<template slot="rows" slot-scope="props" class="actions">
				<td class="is-not-selectable col-1">
					{{ props.row.code }}
				</td>
				<td class="name-module col-2">
					{{ props.row.name }}
				</td>
				<td class="col-3">
				<app-tooltip-button
						color="blue"
						class="no-movil"
						:width="25"
						img="/static/img/icons/detail.svg"
						text="Diccionario de Datos"
						@click-icon="$emit('click-icon', { action: 'dictionary', row: props.row })"
					/>
					<app-tooltip-button
						v-if="canEdit"
						color="success"
						class="no-movil"
						:width="25"
						:disabled="disabledButtons"
						img="/static/img/icons/edit.svg"
						text="Editar"
						@click-icon="$emit('click-icon', { action: 'edit', row: props.row })"
					/>
					<app-tooltip-button
						v-if="canDelete"
						class="no-movil"
						:width="25"
						color="error"
						:disabled="disabledButtons"
						img="/static/img/actions-list/delete.svg"
						text="Eliminar"
						@click-icon="$emit('click-icon', { action: 'delete', row: props.row })"
					/>
					<div class="collapse-menu">
						<v-menu>
							<v-btn dark icon slot="activator">
								<v-icon>more_horiz</v-icon>
							</v-btn>
							<v-list>
								<v-list-tile class="btn-menu-content">
									<v-list-tile-title class="menu-content" @click="$emit('click-icon', { action: 'dictionary', row: props.row })">
										<img src="/static/img/icons/detail.svg"
										alt="icon-dictionary"
										class="menu-option-icon"
										width="15px"
										height="15px"
										>
										<span class="ml-1 dictionary">Diccionario de Datos</span>
									</v-list-tile-title>
								</v-list-tile>
								<v-list-tile v-if="canEdit" class="btn-menu-content" @click="$emit('click-icon', { action: 'edit', row: props.row })">
									<v-list-tile-title class="menu-content">
										<img src="/static/img/icons/edit.svg"
										alt="icon-edit"
										:disabled="disabledButtons"
										width="15px"
										height="15px">
										<span class="ml-1 edit">Editar</span>
									</v-list-tile-title>
								</v-list-tile>
								<v-list-tile v-if="canDelete" class="menu-content" @click="$emit('click-icon', { action: 'delete', row: props.row })">
									<img
									src="/static/img/actions-list/delete.svg"
									:disabled="disabledButtons"
									alt="icon-delete"
									height="15px"
									width="15px"
									>
									<span class="ml-1 delete">Eliminar</span>
								</v-list-tile>
							</v-list>
						</v-menu>
					</div>
				</td>
			</template>
		</app-table>
	</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';
import permissions from '@/mixins/permissions';

function disabledButtons() {
	const userI = typeof this.$userInfo === 'string' ? JSON.parse(this.$userInfo) : this.$userInfo;
	const notFranchise = userI && (userI.company.franchise === null || userI.company.franchise === 0);
	const fatherFranchise = userI && userI.company
		&& userI.company.franchise
		&& userI.subsidiary.father
		? userI.company.franchise === 1 && userI.subsidiary.father === 1 : false;
	return !notFranchise && !fatherFranchise;
}

function data() {
	return {
		columns: [
			{ id: 1, name: 'Código Módulo', value: 'code', checked: true, visible: true, movil: true },
			{ id: 2, name: 'Nombre', value: 'name', checked: true, visible: true, movil: true },
			{ id: 3, name: 'Acciones', checked: true, visible: true, flagVisible: true, movil: true },
		],
	};
}

export default {
	name: 'modules-list',
	mixins: [permissions],
	components: {
		appTooltipButton,
	},
	data,
	computed: {
		disabledButtons,
	},
	props: {
		currentPage: {
			default: 1,
			type: Number,
		},
		lastPage: {
			type: Number,
			default: 1,
		},
		rows: {
			type: Array,
			default: () => [],
		},
	},
};
</script>

<style lang="scss" scoped>
.module-list {
	padding: 0 48px;

	@media (max-width: 800px) {
		padding: 0 12px;
	}
}

.col-1 {
	@media (max-width: 768px) {
		display: grid;
		grid-column: 1/2;
		grid-row: 1;
		line-height: 32px;
		padding-left: 7px !important;
		text-align: left !important;
	}
}

.col-2 {
	@media (max-width: 768px) {
		border-right: none !important;
		display: grid;
		grid-column: 2/3;
		grid-row: 1;
		line-height: 32px;
		padding-left:  37px !important;
		text-align: left !important;
	}
}

.col-3 {
	display: flex;
	justify-content: center;

	@media (max-width: 768px) {
		grid-column: 3/4;
		justify-content: flex-end;
		padding-right: 13px !important;
		grid-row: 1;
	}
}

.collapse-menu {
	display: none;

	@media (max-width: 768px) {
		align-items: center;
		display: block;
		grid-column: 4/5;
		grid-row: 1;
		height: 100%;
		justify-content: center;

		.v-menu {
			align-items: center;
			display: flex;
			height: 100%;
			justify-content: center;

			.v-btn {
				background-color: color(btn-green);
				height: 25px;
				margin: 0;
				width: 25px;
			}
		}

	}
}

.btn-menu-content {
	border-bottom: 1px solid color(grey-background-table);
}

.menu-content {
	align-items: center;
	color: color(red-icon);
	display: grid;
	font-family: font(AvenirRegular);
	font-size: size(small) !important;
	grid-column-gap: 3px;
	grid-template-columns: 15px 1fr;
	width: 175px;

	.delete {
		color: white;
	}

	.edit {
		color: color(btn-green);
	}

	.dictionary {
		color: map-get($colors, secondary);
	}

	.delete {
		color: map-get($colors, red-icon);
		font-size: map-get($sizes, small);
	}
}
.btnActions {
		margin: 0;
		background-color:#33cfc7;
		height:20px;
		width:20px;
	}
.btnClose {
		margin: 0;
		background-color:#f58a93;
		height:20px;
		width:20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/modules/modules-list.vue